import { useWorkScheduleConfigJsonListAtom } from "store/atoms";
import {
  useDetailKey,
  useGetPageFromPath,
  useIsSingleProcessPage,
  useMidgardIdHubletPage,
  useSummaryGroup,
  useVisibleGroups,
  useWorkScheduleIdOnCurrentPage,
} from "../../utils/customHooks/genericHooks";
import { useMemo } from "react";

export function NavTitle() {
  const navTitle = useNavTitle();
  return <div className={`departmentName`}>{navTitle}</div>;
}

export default function useNavTitle() {
  const visibleGroups = useVisibleGroups();
  const summaryGroup = useSummaryGroup();
  const {
    isTimelinePage,
    isProcessTilesPage,
    isHelpPage,
    isSettingsPage,
    isGroupTilesPage,
  } = useGetPageFromPath();
  const isSingleProcessPage = useIsSingleProcessPage();

  const [workSchedules] = useWorkScheduleConfigJsonListAtom();
  const workScheduleId = useWorkScheduleIdOnCurrentPage();
  const detailKey = useDetailKey();
  const midgardIdHubletPage = useMidgardIdHubletPage();
  return useMemo(() => {
    const currentWorkSchedule = workSchedules.find(
      ws => ws.id === workScheduleId
    );
    const processGroup = visibleGroups.find(
      g => g.summaryGroup === summaryGroup
    );
    const processGroupName = processGroup?.longName;

    const singleProcessName = midgardIdHubletPage
      ? visibleGroups
          .flatMap(group => group.processes)
          .find(proc => proc.midgardId === midgardIdHubletPage)?.name
      : processGroup?.processes[detailKey]?.name;

    if (isGroupTilesPage) {
      return currentWorkSchedule?.name;
    }
    if (isTimelinePage || isProcessTilesPage) {
      return processGroupName;
    }
    if (isSingleProcessPage) {
      return singleProcessName;
    }
    if (isHelpPage) {
      return "Help & Feedback";
    }
    if (isSettingsPage) {
      return "Settings";
    }
    return null;
  }, [
    workSchedules,
    visibleGroups,
    summaryGroup,
    workScheduleId,
    detailKey,
    midgardIdHubletPage,
    isGroupTilesPage,
    isTimelinePage,
    isProcessTilesPage,
    isSingleProcessPage,
    isHelpPage,
    isSettingsPage,
  ]);
}
